const toBoolean = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

export const buildEducationalMaterialShortLinkData = (
  material,
  encryptData,
  { isPublicSite, tumorSiteId } = {}
) => {
  const resolvedTumorSiteId =
    tumorSiteId ||
    material.tumorSiteId ||
    (material.tumorSite && material.tumorSite.id);
  const resolvedTumorSiteName =
    typeof material.tumorSite === "object"
      ? material.tumorSite.name
      : material.tumorSite;

  return [
    material.id,
    toBoolean(isPublicSite),
    resolvedTumorSiteId,
    material.type,
    false,
    "none",
    resolvedTumorSiteName,
    toBoolean(material.isShowPublicSite),
  ]
    .map((value) => encryptData(value != null ? value : ""))
    .join("/");
};
